import { render, staticRenderFns } from "./stopRate.vue?vue&type=template&id=ed2b8dd2&"
import script from "./stopRate.vue?vue&type=script&lang=js&"
export * from "./stopRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports